import React, { createContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, ListGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Button, ListGroupItem } from '@cordata/buffet';
import { toast } from 'react-toastify';
import { orderBy, debounce } from 'lodash';
import snakecaseKeys from 'snakecase-keys';

import { authorizedInstance as Authorized } from '~/utils';

const DuplicateContext = createContext();

const Duplicate = ({
  children,
}) => {
  const [api, setApi] = useState();
  const [pageUrl, setPageUrl] = useState();
  const [labelKey, setLabelKey] = useState();
  const [duplicateList, setDuplicateList] = useState([]);
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  const toastId = useRef(null);

  const notifyDupCheck = () => {
    toastId.current = toast('Checking for duplicates ...', { autoClose: false });
  };

  const notifyDupFound = () =>
    toast.update(toastId.current, { render: 'Duplicates found!', type: toast.TYPE.WARNING, autoClose: 2500 });

  const notifyDupNotFound = () =>
    toast.update(toastId.current, { render: 'No duplicates found!', type: toast.TYPE.INFO, autoClose: 2500 });

  const notifyDupClose = () =>
    toast.dismiss();

  const handleDuplicateCheck = debounce((values) => {
    let labelKeys = {};

    if (labelKey.includes(',')) {
      labelKeys = labelKey
        .split(',')
        .reduce((a, m) => ({
          ...a,
          [m]: values[m],
        }), {});
    } else {
      labelKeys = {
        [labelKey]: values[labelKey],
      };
    }

    if (Object.values(labelKeys)) {
      notifyDupCheck();

      Authorized
        .get(`api/${api}-search`, {
          params: snakecaseKeys({
            ...labelKeys,
            orgUid: localStorage.getItem('org'),
          }),
        }).then(({ data: { data: r } }) => {
          if (r.length) {
            notifyDupFound();
            setDuplicateList(orderBy(r, [`attributes.${Object.keys(labelKeys)[0]}`]));
            toggle();
          } else {
            notifyDupNotFound();
          }
        })
        .catch(notifyDupClose);
    }
  }, 1000);

  return (
    <DuplicateContext.Provider
      value={{
        api,
        setApi,

        pageUrl,
        setPageUrl,

        labelKey,
        setLabelKey,

        handleDuplicateCheck,
      }}
    >
      {children}

      <Modal isOpen={open}>
        <ModalHeader>Duplicates Found!</ModalHeader>

        <ModalBody>
          <p>
            The following is a list of possible duplicates.{' '}
            You may click one to go to that item to edit.
          </p>

          <ListGroup>
            {duplicateList.map(dup => (
              <ListGroupItem
                action
                tag={Link}
                to={`/${pageUrl}/${dup.id}`}
                onClick={toggle}
              >
                {dup.attributes[labelKey.includes(',') ? labelKey.split(',')[0] : labelKey]}
              </ListGroupItem>
              ))}
          </ListGroup>
        </ModalBody>

        <ModalFooter>
          <Button color="tertiary" outline onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </DuplicateContext.Provider>
  );
};

Duplicate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Duplicate;
export { DuplicateContext };
